import React, { useState, useEffect } from 'react';
import { useGlobal } from 'reactn';
import { Link } from 'react-router-dom';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import { notification } from 'antd';
import leafIcon from '../../assets/paperless.png';
import checkIcon from '../../assets/CheckIcon.png';
import xIcon from '../../assets/XIcon.png';
import autoPayDocument from '../../assets/documents/AUTO_PAY_FORM.pdf';

import api from '../../../api';

const GoPaperless = ({ customerSvcInfo, ...rest }) => {
  const [hasEbill, setHasEbill] = useState(false);
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(0);
  const [confirmation, setConfirmation] = useState(false);
  const [updateEStatus, setUpdateEstatus] = useState(false);

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  const AUTO_PAY = selectedServiceAccount?.data?.AUTO_PAY;

  useEffect(() => {
    if (selectedServiceAccount !== undefined) {
      setHasEbill(selectedServiceAccount?.eBillStatus?.data?.EBILL_FLAG);
    }
  }, [setHasEbill, selectedServiceAccount]);

  window.onclick = (e) => {
    if (e.target.id === 'optionsWrapper') {
      setUpdateEstatus(false);
      setConfirmation(false);
    }
  };

  const signupHandler = async () => {
    try {
      setLoading(true);
      await api.updateEBill(
        selectedServiceAccount.data.ACCOUNT,
        selectedServiceAccount.data.CUST_CODE,
        flag
      );
      setConfirmation(true);
      setUpdateEstatus(false);
      flag === null && setHasEbill(false);
      flag === 1 && setHasEbill(true);
      flag === 2 && setHasEbill(true);
      setLoading(false);
      notification.success({
        message: `Your paperless preferences have been successfully updated`,
      });
    } catch (err) {
      console.log(err.response);
      setLoading(false);
    }
  };

  const renderPaperless = () => (
    <Card title="Go Paperless" {...rest}>
      <div className="flex align-center mb-5 mt-5">
        {!hasEbill ? (
          <img className="h-5 w-5 my-0 mr-3" src={xIcon} alt="x-icon" />
        ) : (
          <img className="h-5 w-6 my-0 mr-2" src={checkIcon} alt="x-icon" />
        )}
        {!hasEbill ? (
          <p className={`text-bold w-full h-10 my-0 mx-0`}>
            You are not enrolled in Go Paperless
          </p>
        ) : (
          <p className={`text-bold w-full h-10 my-0 mx-0`}>
            You are enrolled in Go Paperless
          </p>
        )}
      </div>
      <Button
        iconUrl={leafIcon}
        className="h-32 mx-auto w-full flex justify-center items-center"
        onClick={() => setUpdateEstatus(true)}
      >
        <p className="mb-0">
          {!hasEbill ? 'Signup for paperless billing' : 'Deactivate'}
        </p>
      </Button>
    </Card>
  );

  const renderConfirmation = () => (
    <Card title="Go Paperless" {...rest}>
      <div
        className="flex-col w-full h-full"
        onClick={() => {
          setConfirmation(false);
          setUpdateEstatus(false);
        }}
      >
        <h3 className="font-bold mx-auto mb-8 text-center">
          YOUR ELECTRONIC BILLING HAS BEEN SUCCESSFULLY SET TO{' '}
          {flag === 1
            ? 'E-BILLING ONLY'
            : flag === 2
            ? 'E-BILLING & PAPER BILL'
            : 'PAPER BILL ONLY'}
          !
        </h3>
        <p className="font-bold mx-auto text-center">THANK YOU.</p>
      </div>
    </Card>
  );

  const renderEnrollments = () => (
    <Card title="Your Enrollments" {...rest}>
      <div className="flex align-center">
        {!AUTO_PAY ? (
          <img className="h-5 w-5 my-0 mr-3" src={xIcon} alt="x-icon" />
        ) : (
          <img className="h-5 w-6 my-0 mr-2" src={checkIcon} alt="x-icon" />
        )}

        <p className={`text-bold w-1/2 h-10 my-0 mx-0`}>Automatic Bill Pay</p>
        <a
          className="my-0 ml-auto"
          href={autoPayDocument}
          target="_blank"
          rel="noopener noreferrer"
        >
          Enroll 
        </a>
      </div>

      <div className="flex">
        <img className="h-5 w-6 my-0 mr-2" src={checkIcon} alt="x-icon" />
        <p className={`text-bold w-1/2 h-10 my-0 mx-0`}>Paperless Billing</p>
        <Link to="/user/profile" className="my-0 ml-auto">
          Change Settings 
        </Link>
      </div>
    </Card>
  );

  const renderOptions = () => (
    <Card title="Select Billing Preference" {...rest}>
      <div
        className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 mt-0 mb-2 mx-auto p-2 cursor-pointer ${
          flag === 1 && 'bg-blue-light text-white'
        }`}
        onClick={() => setFlag(1)}
      >
        Request E-Billing Only
      </div>
      <div
        className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 mt-0 mb-2 mx-auto p-2 cursor-pointer ${
          flag === null && 'bg-blue-light text-white'
        }`}
        onClick={() => setFlag(null)}
      >
        Request Paper Bill Only
      </div>
      <div
        className={`text-bold border-grey border-solid border-2 border-grey-600 w-full h-10 my-0 mx-auto p-2 cursor-pointer ${
          flag === 2 && 'bg-blue-light text-white'
        }`}
        onClick={() => setFlag(2)}
      >
        Request E-Billing & Paper Bill
      </div>
      <Button
        iconUrl={leafIcon}
        className="mx-auto w-full flex justify-center items-center"
        onClick={signupHandler}
        loading={loading}
      >
        Submit Request
      </Button>
      <Button
        disabled={loading}
        className="mx-auto w-full flex justify-center items-center"
        onClick={() => setUpdateEstatus(false)}
        secondary
      >
        Cancel
      </Button>
    </Card>
  );

  return (
    <>
      {!updateEStatus && !confirmation && renderPaperless()}
      {updateEStatus && renderOptions()}
      {confirmation && !updateEStatus && renderConfirmation()}
    </>
  );
};

export default GoPaperless;
